<template>
  <v-card>
    <v-row class="pt-4 px-3 ma-0">
      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="filter.search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          outlined
          width="20"
          dense
          hide-details
          clearable
          @input="updateQuery"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="filter.lga"
          label="Filter by Lga"
          :items="ibomLga"
          outlined
          dense
          clearable
          @input="updateQuery"
        >
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="filter.phone"
          append-icon="mdi-magnify"
          label="Filter by Phone"
          single-line
          outlined
          width="20"
          dense
          clearable
          hide-details
          @input="updateQuery"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="filter.gender"
          label="Filter Gender"
          :items="['M', 'F']"
          outlined
          width="20"
          dense
          clearable
          @input="updateQuery"
        ></v-select>
      </v-col>
    </v-row>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="farmers"
      :options.sync="options"
      :server-items-length="totalFarmers"
      :loading="loading"
      show-select
      :footer-props="footerProps"
    >
      <template v-slot:top>
        <v-toolbar flat colour="white">
          <v-toolbar-title>Farmers</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="ma-2"
            text
            >
              <v-icon left>mdi-filter</v-icon>
                filter
            </v-btn>
            <v-btn
            color="primary"
            class="ma-2"
            text
            >
              <v-icon left>mdi-download</v-icon>
                Export
            </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.photo`] = "{ item }">
        <v-avatar size="30">
          <img :src="`https://akfimsimages.s3.us-east-2.amazonaws.com/${item.photo}`" lazy-src="../assets/avatar.jpg">
        </v-avatar>
      </template>
      <!--fullname//////////////-->
      <template v-slot:[`item.full_name`] = "{ item }">
        {{ item.first_name }} {{ item.last_name }}
      </template>
      <template v-slot:[`item.actions`] = "{ item }">
        <v-btn
          color="primary"
          class="ml-n2"
          depressed
          small
          @click="editFarmer(item._id)"
        >
          More
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import FarmerService from '../services/AkfimsFarmerService'
import { ibomLga } from '../utils/Statelga'
export default {
  data () {
    return {
      ibomLga,
      loading: true,
      options: {
        itemsPerPage: 20,
        page: 1,
        sortBy: [],
        sortDesc: 'true'
      },
      footerProps: {
        showFirstLastPage: true,
        'items-per-page-options': [10, 15, 20, 25]
      },
      itemsPerpage: 20,
      filter: {
        search: '',
        state: '',
        lga: '',
        phone: '',
        gender: ''
      },
      totalFarmers: 0,
      enumeratorid: '',
      error: '',
      selected: [],
      pageItems: [10, 15, 20, 25],
      headers: [
        {
          text: '',
          align: 'start',
          value: 'photo',
          sortable: false
        },
        { text: 'Farmers', value: 'full_name' },
        { text: 'Phone', value: 'phone' },
        { text: 'Gender', value: 'gender' },
        { text: 'Age', value: 'age' },
        { text: 'Qualification', value: 'edu_qua' },
        { text: 'State', value: 'state' },
        { text: 'Field LGA', value: 'lga' },
        { text: 'Actions', value: 'actions' }
      ],
      farmers: []
    }
  },
  /* async mounted () {
    try {
      const query = {
        enumeratorid: this.$route.query.enumeratorid,
        search: this.search,
        lga: this.lga,
        phone: this.phone,
        gender: this.gender
      }
      for (const k in query) if (!query[k]) delete query[k]
      console.log(query.enumeratorid)
      this.farmers = await FarmerService.getFarmers()
    } catch (err) {
      this.error = err.message
    }
  }, */
  methods: {
    editFarmer (id) {
      this.$router.push({ name: 'Akfimsfarmer', params: { id: id } })
    },
    async updateQuery () {
      const query = Object.entries(this.filter).reduce((acc, [key, val]) => {
        if (!val) return acc
        return { ...acc, [key]: val }
      }, {})
      const filter = Object.entries(this.options).reduce((acc, [key, val]) => {
        if (!val) return acc
        return { ...acc, [key]: val }
      }, {})
      /* this will update your URL query based on toggled values.
        Be sure to update the Name to what your actual route is */
      if ((Object.entries(query).length === 0 && query.constructor === Object) || (Object.entries(filter).length === 0 && filter.constructor === Object)) {
        this.$router.replace({ name: 'Akfimstable', query: { ...query, ...filter } })
        const result = await FarmerService.getFarmers(this.options, query)
        this.farmers = result.farmers
        this.totalFarmers = result.count
        this.loading = false
      } else if ('enumeratorid' in query && !('search' in query || 'lga' in query || 'phone' in query || 'gender' in query)) {
        const result = await FarmerService.getFarmers(this.options, query)
        this.farmers = result.farmers
        this.totalFarmers = result.count
        this.loading = false
      } else if ('enumeratorid' in query && ('search' in query || 'lga' in query || 'phone' in query || 'gender' in query)) {
        clearTimeout(this._timer)
        this.$router.replace({ name: 'Akfimstable', query: { ...query, ...filter } })
        this.farmers = []
        this._timer = setTimeout(function () {
          this.fetchData()
        }.bind(this), 1000)
      } else {
        this.$router.replace({ name: 'Akfimstable', query: { ...query, ...filter } })
        clearTimeout(this._timer)
        this.farmers = []
        this._timer = setTimeout(function () {
          this.fetchData()
        }.bind(this), 1000)
      }
    },
    async fetchData () {
      const query = Object.entries(this.filter).reduce((acc, [key, val]) => {
        if (!val) return acc
        return { ...acc, [key]: val }
      }, {})
      const result = await FarmerService.getFarmers(this.options, query)
      this.farmers = result.farmers
      this.totalFarmers = result.count
      this.loading = false
    }
  },
  /* watch: {
    '$route.path': {
      immediate: true,
      async handler (enumerator) {
        const query = {
          enumeratorid: this.$route.query.enumeratorid,
          search: this.search,
          lga: this.lga,
          phone: this.phone,
          gender: this.gender
        }
        for (const k in query) if (!query[k]) delete query[k]
        console.log(query.enumeratorid)
        this.farmers = await FarmerService.getFarmers(query)
      }
    }
  } */
  /* watch: {
    '$route.query.enumeratorid': {
      immediate: true,
      async handler (enumeratorid) {
        console.log(enumeratorid)
        this.farmers = await FarmerService.getFarmers(enumeratorid)
      }
    }
  } */
  /* methods: {
    editFarmer (id) {
      this.$router.push({ name: 'Akfimsfarmer', params: { id: id } })
    },
    async getData () {
      const filter = Object.entries(this.options).reduce((acc, [key, val]) => {
        if (!val) return acc
        return { ...acc, [key]: val }
      }, {})
      const result = await FarmerService.getFarmers(query, filter)
      this.farmers = result.farmers
      this.totalFarmers = result.count
      this.loading = false
    }
  }, */
  watch: {
    '$route.path': {
      immediate: true,
      async handler () {
        this.updateQuery()
      }
    },
    options: {
      handler (value) {
        console.log(value)
        // this.getData()
        this.updateQuery()
      },
      deep: true
    },
    '$route.query.search': {
      immediate: true,
      async handler (value) {
        this.filter.search = value
      }
    },
    '$route.query.enumeratorid': {
      immediate: true,
      async handler (value) {
        this.filter.enumeratorid = value
        // this.updateQuery()
      }
    },
    '$route.query.state': {
      immediate: true,
      async handler (value) {
        this.filter.state = value
      }
    },
    '$route.query.phone': {
      immediate: true,
      async handler (value) {
        this.filter.phone = value
      }
    },
    '$route.query.lga': {
      immediate: true,
      async handler (value) {
        this.filter.lga = value
      }
    },
    '$route.query.gender': {
      immediate: true,
      async handler (value) {
        this.filter.gender = value
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
